let staticData = {
  visibilityOptions: {
    0: 'Clear',
    1: 'Light Rain/Fog/Smoke',
    2: 'Moderate Rain/Fog/Smoke',
    3: 'Heavy Rain/Fog/Smoke'
  },

  lightOptions: {
    0: 'Full Light',
    1: 'Partial Light',
    2: 'Dim Light',
    3: 'Total Darkness'
  },

  glareOptions: {
    0: 'No Glare',
    1: 'Weak Glare',
    2: 'Moderate Glare',
    3: 'Blinding Glare'
  },

  windOptions: {
    0: 'None or Light Breeze',
    1: 'Light Winds',
    2: 'Moderate Winds',
    3: 'Strong Winds'
  },

  rangedLOSOptions: {
    0: 'Direct line of sight to target',
    1: 'Firing from cover with imaging device',
    2: 'Firing blind'
  },

  weaponTypeOptions: {
    taser: 'Taser',
    holdout: 'Hold-Out',
    lPistol: 'Light Pistol',
    hPistol: 'Heavy Pistol',
    mPistol: 'Machine Pistol',
    smg: 'SMG',
    ar: 'Assault Rifle',
    fShotgun: 'Shotgun (flechette)',
    sShotgun: 'Shotgun (slug)',
    sniper: 'Sniper Rifle',
    lmg: 'Light Machinegun',
    hmg: 'Medium/Heavy Machinegun',
    cannon: 'Assault Cannon',
    gLaunch: 'Grenade Launcher',
    mLaunch: 'Missile Launcher',
    bow: 'Bow',
    lCross: 'Light Crossbow',
    mCross: 'Medium Crossbow',
    hCross: 'Heavy Crossbow',
    knife: 'Thrown Knife',
    shuriken: 'Shuriken',
    sGrenade: 'Standard Grenade',
    aGrenade: 'Aerodynamic Grenade'
  },

  compensationGear: {
    implantedFlareCompensation: 'Flare compensation (implant)',
    externalFlareCompensation: 'Flare compensation (external)',
    imageMagnification: 'Image magnification',
    lowLightVision: 'Low-light vision',
    thermographicVision: 'Thermographic vision',
    sunglasses: 'Sunglasses',
    ultrasound: 'Ultrasound'
  },

  attackGear: {
    smartgun: 'Smartgun (wireless)',
    implantedSmartlink: 'Smartlink (implanted)',
    externalSmartlink: 'Smartlink (external)',
    laserSight: 'Laser Sight (wireless)',
    tracerRounds: 'Tracer rounds',
    periscope: 'Periscope'
  },

  rangedSitMods: {
    firingFromVehicle: 'Firing from moving vehicle',
    inMeleeCombat: 'In melee combat',
    running: 'Running',
    offhand: 'Using off-hand weapon',
    calledShot: 'Called shot'
  }
}

export default staticData



// WEBPACK FOOTER //
// ./src/data/modifiers.js